import axios from '@/core/axios';

import { BankStatementImportResponse } from './bank-statement-imports.types';

export class BankStatementImportsService {
  preview(file: File): Promise<BankStatementImportResponse> {
    const formData = new FormData();
    formData.append('file', file);
    return axios
      .post<BankStatementImportResponse>('/accounting/bank-statement-imports/preview', formData)
      .then(resp => resp?.data);
  }
}

export const bankStatementImportsService = new BankStatementImportsService();
